(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function ensurePortal() {
    var modal = qs('#ta-contact-modal');
    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);

    var wa = qs('.ta-whatsapp-fallback');
    var panel = qs('#ta-whatsapp-panel');
    if (wa && wa.parentElement !== document.body) document.body.appendChild(wa);
    if (panel && panel.parentElement !== document.body) document.body.appendChild(panel);
  }

  function openModal() {
    ensurePortal();
    var modal = qs('#ta-contact-modal');
    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    modal.style.display = 'flex';
    modal.style.visibility = 'visible';
    modal.style.opacity = '1';
    modal.style.zIndex = '2147483647';
    modal.style.pointerEvents = 'auto';

    document.documentElement.classList.add('ta-contact-modal-open');
    document.body.classList.add('ta-contact-modal-open');

    qsa('[data-ta-contact-open]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });

    setTimeout(function () {
      var first = qs('#TAHeaderLeadName', modal) || qs('input, textarea, select, button', modal);
      if (first && first.focus) first.focus({ preventScroll: true });
    }, 80);
  }

  function closeModal() {
    var modal = qs('#ta-contact-modal');
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.style.display = 'none';

    document.documentElement.classList.remove('ta-contact-modal-open');
    document.body.classList.remove('ta-contact-modal-open');
    qsa('[data-ta-contact-open]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
  }

  function openWaPanel() {
    ensurePortal();
    var panel = qs('#ta-whatsapp-panel');
    var btn = qs('.ta-whatsapp-fallback');
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeWaPanel() {
    var panel = qs('#ta-whatsapp-panel');
    var btn = qs('.ta-whatsapp-fallback');
    if (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    }
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function isElementVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var rect = el.getBoundingClientRect();
    if (rect.width < 20 || rect.height < 20) return false;
    if (rect.bottom < 0 || rect.right < 0 || rect.top > window.innerHeight || rect.left > window.innerWidth) return false;
    var style = window.getComputedStyle(el);
    return style && style.display !== 'none' && style.visibility !== 'hidden' && parseFloat(style.opacity || '1') > 0.05;
  }

  function isActuallyOnScreen(el) {
    if (!isElementVisible(el) || !document.elementFromPoint) return false;
    var rect = el.getBoundingClientRect();
    var points = [
      [rect.left + rect.width / 2, rect.top + rect.height / 2],
      [Math.min(rect.right - 4, rect.left + 24), Math.min(rect.bottom - 4, rect.top + 24)],
      [Math.max(rect.left + 4, rect.right - 24), Math.max(rect.top + 4, rect.bottom - 24)]
    ];

    for (var i = 0; i < points.length; i++) {
      var x = Math.max(1, Math.min(window.innerWidth - 1, points[i][0]));
      var y = Math.max(1, Math.min(window.innerHeight - 1, points[i][1]));
      var hit = document.elementFromPoint(x, y);
      if (!hit) continue;
      if (hit === el || (el.contains && el.contains(hit)) || (hit.contains && hit.contains(el))) return true;
    }
    return false;
  }

  function isExternalWhatsAppCandidate(el) {
    if (el.closest && (el.closest('.ta-whatsapp-fallback') || el.closest('#ta-whatsapp-panel') || el.closest('.ta-proximamente-page-card__interest') || el.closest('.ta-proximamente-page-card__button') || el.closest('.ta-auto-product__interest-button'))) return false;
    if (!isActuallyOnScreen(el)) return false;

    var href = el.getAttribute('href') || '';
    var src = el.getAttribute('src') || '';
    var haystack = [
      el.id || '',
      el.className || '',
      href,
      src,
      el.getAttribute('aria-label') || '',
      el.getAttribute('title') || '',
      el.textContent || ''
    ].join(' ').toLowerCase();

    var mentionsWhatsapp = haystack.indexOf('whatsapp') !== -1 || haystack.indexOf('wa.me') !== -1 || haystack.indexOf('api.whatsapp') !== -1 || haystack.indexOf('empieza una convers') !== -1;
    if (!mentionsWhatsapp) return false;

    var rect = el.getBoundingClientRect();
    var style = window.getComputedStyle(el);
    var isFloating = style.position === 'fixed' || style.position === 'sticky';
    var lowerRight = rect.right > window.innerWidth * 0.50 && rect.bottom > window.innerHeight * 0.45;
    var isDirectWhatsappLink = href.indexOf('wa.me') !== -1 || href.indexOf('api.whatsapp') !== -1 || href.indexOf('whatsapp://') !== -1;

    /* No escondemos nuestro botón por simples textos/containers invisibles de la app.
       Solo lo ocultamos si el widget externo parece realmente visible y accionable. */
    return lowerRight && (isFloating || isDirectWhatsappLink || haystack.indexOf('empieza una convers') !== -1);
  }

  function hasExternalWhatsAppWidget() {
    var fallback = qs('.ta-whatsapp-fallback');
    var panel = qs('#ta-whatsapp-panel');
    var oldFallbackPointer = fallback ? fallback.style.pointerEvents : '';
    var oldPanelPointer = panel ? panel.style.pointerEvents : '';

    /* Al detectar, ignoramos nuestro propio fallback para poder ver si hay un widget real debajo. */
    if (fallback) fallback.style.pointerEvents = 'none';
    if (panel) panel.style.pointerEvents = 'none';

    try {
      var candidates = qsa('a, button, iframe, div, section, span');
      for (var i = 0; i < candidates.length; i++) {
        if (isExternalWhatsAppCandidate(candidates[i])) return true;
      }
      return false;
    } finally {
      if (fallback) fallback.style.pointerEvents = oldFallbackPointer;
      if (panel) panel.style.pointerEvents = oldPanelPointer;
    }
  }

  function hideExternalWhatsAppWidgets() {
    /* Dejamos solo nuestro WhatsApp del tema. Ocultamos widgets de apps externas
       que puedan aparecer en otras páginas para evitar doble botón. */
    var candidates = qsa('a, button, iframe, div, section, span');
    candidates.forEach(function (el) {
      if (!el || !el.closest) return;
      if (el.closest('.ta-whatsapp-fallback') || el.closest('#ta-whatsapp-panel') || el.closest('.ta-proximamente-page-card__interest') || el.closest('.ta-proximamente-page-card__button') || el.closest('.ta-auto-product__interest-button')) return;

      var href = (el.getAttribute && el.getAttribute('href')) || '';
      var src = (el.getAttribute && el.getAttribute('src')) || '';
      var haystack = [
        el.id || '',
        el.className || '',
        href,
        src,
        (el.getAttribute && el.getAttribute('aria-label')) || '',
        (el.getAttribute && el.getAttribute('title')) || '',
        el.textContent || ''
      ].join(' ').toLowerCase();

      var looksLikeWhatsapp =
        haystack.indexOf('whatsapp') !== -1 ||
        haystack.indexOf('wa.me') !== -1 ||
        haystack.indexOf('api.whatsapp') !== -1 ||
        haystack.indexOf('empieza una convers') !== -1;

      if (!looksLikeWhatsapp) return;

      try {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.setAttribute('aria-hidden', 'true');
      } catch (e) {}
    });
  }

  function syncWhatsappFallback() {
    ensurePortal();
    hideExternalWhatsAppWidgets();

    var fallback = qs('.ta-whatsapp-fallback');
    var panel = qs('#ta-whatsapp-panel');
    if (!fallback) return;

    fallback.classList.remove('ta-whatsapp-fallback--hidden');
    fallback.style.display = 'inline-flex';
    fallback.style.visibility = 'visible';
    fallback.style.opacity = '1';
    fallback.style.pointerEvents = 'auto';
    if (panel) panel.style.display = panel.classList.contains('is-open') ? 'block' : '';
  }

  function bind() {
    ensurePortal();

    qsa('[data-ta-contact-open]').forEach(function (btn) {
      if (btn.dataset.taContactBound === 'true') return;
      btn.dataset.taContactBound = 'true';
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        openModal();
      });
    });

    qsa('[data-ta-contact-close]').forEach(function (btn) {
      if (btn.dataset.taContactCloseBound === 'true') return;
      btn.dataset.taContactCloseBound = 'true';
      btn.addEventListener('click', function (ev) { ev.preventDefault(); closeModal(); });
    });

    qsa('[data-ta-wa-toggle]').forEach(function (btn) {
      if (btn.dataset.taWaBound === 'true') return;
      btn.dataset.taWaBound = 'true';
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var panel = qs('#ta-whatsapp-panel');
        if (panel && panel.classList.contains('is-open')) closeWaPanel(); else openWaPanel();
      });
    });

    qsa('[data-ta-wa-close]').forEach(function (btn) {
      if (btn.dataset.taWaCloseBound === 'true') return;
      btn.dataset.taWaCloseBound = 'true';
      btn.addEventListener('click', function (ev) { ev.preventDefault(); closeWaPanel(); });
    });
  }

  function init() {
    bind();
    syncWhatsappFallback();
    setTimeout(syncWhatsappFallback, 800);
    setTimeout(syncWhatsappFallback, 1800);
    setTimeout(syncWhatsappFallback, 3500);

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') { closeModal(); closeWaPanel(); }
    });

    document.addEventListener('click', function (ev) {
      var panel = qs('#ta-whatsapp-panel');
      if (!panel || !panel.classList.contains('is-open')) return;
      if (ev.target.closest && (ev.target.closest('#ta-whatsapp-panel') || ev.target.closest('.ta-whatsapp-fallback'))) return;
      closeWaPanel();
    });

    var observer = new MutationObserver(function () {
      bind();
      syncWhatsappFallback();
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
